import { Link } from "react-router-dom";
import * as motion from "motion/react-client"
import StickyNavbar from "../navbar";

const SectionTwo = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  return (
    <div>
      <StickyNavbar />
      <motion.div
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 lg:text-lg"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <div className="space-y-10">
          <motion.h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-center capitalize"
            variants={fadeIn}
          >
            Who does research?
          </motion.h2>

          {/* Example role card with motion */}
          <motion.div variants={fadeIn}>
            <h2 className="text-2xl font-bold mb-2  text-[#005FFF]">
              Who should be involved in the research?
            </h2>
            <p className=" text-lg">
              Research participants: Research can be done by many people. Each
              person involved brings a different view that makes research more
              relevant and valuable to the community (1-4, 25).
            </p>
          </motion.div>

          {/* Scientists Section */}
          <motion.div variants={fadeIn}>
            <p className=" text-lg">
              Scientists: Scientists often do research in laboratories, or what
              are called controlled settings. They may be testing theories,
              creating treatments, and collecting data to understand a health
              condition.
            </p>
          </motion.div>
          <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            
            {/* <div className="flex justify-center">
              <img
                src="/images/scientist.png"
                alt="Scientists in a laboratory"
                className="w-full max-w-md rounded-md"
              />
            </div> */}
             <div className="bg-gray-100 rounded-lg p-4">
                <div className="flex justify-center">
                    <div className="w-64 h-40 bg-gray-300 rounded-md"></div>
                </div>
                <p className="text-center text-sm text-gray-500 mt-2">Image placeholder</p>
            </div>
            <p className="text-center text-sm mt-2">
              Researchers in Laboratory. © Rhoda Baer. Source:
            </p>
          </motion.div>

          {/* Community health workers Section */}
          <motion.div variants={fadeIn}>
            <p>
              Community health workers: Working closely within the community,
              health workers have the opportunity to carry out research by
              engaging with local people, and collect data from them in the
              places that they live their daily lives. These connections allow
              them to relate to people in a deeper way and understand the
              community’s needs.
            </p>
          </motion.div>
          <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex justify-center">
              <img
                src="/images/community.png"
                alt="Community health worker engaging with locals"
                className="w-full max-w-md rounded-md"
              />
            </div>
            <p className="text-center text-sm mt-2">
              Figure 3: Community health worker engaging with locals
            </p>
            <p className="text-center text-gray-500 text-sm mt-1">
              Citations: (9-12)
            </p>
          </motion.div>


          <motion.div variants={fadeIn}>
            <p>
              Academics: People working in universities or schools and places of education do research to learn more about various topics. They study information, theories, test ideas, and check if programs or rules work well. They share what they find so others can use it to make good decisions and solve problems. Their research helps connect learning with real-life actions.


            </p>
          </motion.div>
          {/* <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex justify-center">
              <img
                src="/images/community.png"
                alt="Community health worker engaging with locals"
                className="w-full max-w-md rounded-md"
              />
            </div>
            <p className="text-center text-sm mt-2">
              Figure 3: Community health worker engaging with locals
            </p>
            <p className="text-center text-gray-500 text-sm mt-1">
              Citations: (9-12)
            </p>
          </motion.div> */}

          <motion.div variants={fadeIn}>
            <p>
            Healthcare workers: Healthcare workers such as nurses and doctors often carry out research with patients. Research may be focused on improving patient care, understanding health conditions, and finding ways to deliver better healthcare services.
            </p>
          </motion.div>
          <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            {/* <div className="flex justify-center">
              <img
                src="/images/healthcare.png"
                alt="Community health worker engaging with locals"
                className="w-full max-w-md rounded-md"
              />
            </div> */}
             <div className="bg-gray-100 rounded-lg p-4">
                <div className="flex justify-center">
                    <div className="w-64 h-40 bg-gray-300 rounded-md"></div>
                </div>
                <p className="text-center text-sm text-gray-500 mt-2">Image placeholder</p>
            </div>
          
          </motion.div>

          <motion.div variants={fadeIn}>
            <p>
            Local leaders and community groups: Local leaders, faith-based groups, and community groups can play an important part in research. They can support research by encouraging people to take part, and they help researchers understand community values and cultures.
            </p>
          </motion.div>
          <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex justify-center">
              <img
                src="/images/leaders.png"
                alt="Community health worker engaging with locals"
                className="w-full max-w-md rounded-md"
              />
            </div>
           
          </motion.div>
          <motion.div
            className=" rounded-lg p-4"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex justify-center">
              <img
                src="/images/Picture1.png"
                alt="Community health worker engaging with locals"
                className="w-full max-w-md rounded-md"
              />
            </div>
           
          </motion.div>

          {/* Add similar motion effects for other sections */}

          {/* Navigation Buttons */}
          <div className="flex justify-between mt-10">
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <Link to="/chapter1/SectionOne">
                <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                  Previous
                </button>
              </Link>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.2 }}
            >
              <Link to="/chapter1/sectionThree">
                <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                  Next
                </button>
              </Link>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SectionTwo;
